import { render, staticRenderFns } from "./FormEmployee.vue?vue&type=template&id=1bf0faab&"
import script from "./FormEmployee.vue?vue&type=script&lang=js&"
export * from "./FormEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports